<template>
  <el-container class="container">
    <el-header height="50px">
      <div class="sys-name">法鼎商事调解中心-管理后台</div>
      <div class="right-box">
        <!-- <a href="#"><i class="el-icon-chat-dot-square"></i></a>
        <a href="#"><i class="el-icon-setting"></i></a>
        <el-button type="warning" icon="el-icon-user" circle></el-button> -->
        <span>欢迎您，管理员</span>
        <a href="#" @click="logout"><i class="el-icon-switch-button"></i></a>
      </div>
    </el-header>
    <el-container>
      <!-- 导航栏 -->
      <el-aside width="200px">
        <el-menu
          default-active="/index"
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          router
          unique-opened
        >
          <el-menu-item index="/index">
            <i class="el-icon-house"></i>
            <span slot="title">系统首页</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-goods"></i>
              <span>中心简介</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/intro">中心简介</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-shopping-cart-1"></i>
              <span>判决案例</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/judgment">判决案例示例</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-notebook-1"></i>
              <span>调解纠纷</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/mediate">调解纠纷指南</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span>新闻动态</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/news">新闻列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>诉讼服务</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/service">讼服务指南</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>案件查询</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/caselist">案件列表</el-menu-item>
              <el-menu-item index="/caserecord">查询记录</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="7">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>调解员</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/mediator">调解员列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="8">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>系统管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/manager">管理员列表</el-menu-item>
              <el-menu-item index="/complaint">投诉列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <router-view />
        </el-main>
        <el-footer height="30px">
          法鼎商事调解中心 版权所有@2025 All Rights Reserved.
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
export default {
  name: "MainFrame",
  methods: {
    logout() {
      window.sessionStorage.clear();
      this.$router.push("/login");
    },
  },
};
</script>
<style scoped>
.container {
  height: 100%;
}
.el-header {
  background-color: #fff;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  padding-right: 50px;
  line-height: 50px;
}
/* 顶部样式 */
.sys-name {
  /* background-color: green; */
  font-size: 30px;
  /* line-height: 50px; */
}
.right-box {
  /* background-color: blue; */
  /* line-height: 150px; */
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.right-box i,
.right-box span {
  margin: 0 10px;
}

.el-aside {
  background-color: #304156;
  color: #fff;
}
.el-main {
  background-color: #eaedf1;
}
.el-footer {
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-menu-item.is-active {
  background-color: rgb(67.74, 80) !important;
}
</style>